module.exports = __webpack_public_path__ + "img/toplogo.de626f9d.png";